/* global axios */
import ApiClient from './ApiClient';

class OnboardingAPI extends ApiClient {
  constructor() {
    super('onboarding', { accountScoped: false });
  }

  getCurrentStep() {
    return axios.get(`${this.url}/step`);
  }

  getSelectActivity() {
    return axios.get(`${this.url}/select_activity`);
  }

  updateSelectActivity(data) {
    return axios.put(`${this.url}/select_activity`, data);
  }

  getCreateBot() {
    return axios.get(`${this.url}/create_bot`);
  }

  updateCreateBot(data) {
    return axios.put(`${this.url}/create_bot`, data);
  }

  getKnowledgeSources() {
    return axios.get(`${this.url}/knowledge_sources`);
  }

  updateKnowledgeSources(data) {
    return axios.put(`${this.url}/knowledge_sources`, data);
  }

  getReviewInfo() {
    return axios.get(`${this.url}/review_info`);
  }

  updateReviewInfo(data) {
    return axios.put(`${this.url}/review_info`, data);
  }

  getTestBot(activityArea) {
    return axios.get(`${this.url}/step/questions`, {
      params: { activity_area: activityArea },
    });
  }

  publishBot() {
    return axios.put(`${this.url}/publish_bot`);
  }
}

export default new OnboardingAPI();
